import React, { createContext, useCallback, useMemo, useState } from 'react';
import { Data } from '../data/Data';
import { useLotsCommerciaux } from './lotCommercialContext';
import { useNotificationsManager } from './notificationContext';

const ReglementContext = createContext();
const ReglementManagerContext = createContext();

export const ReglementContextProvider = ({ children }) => {

    const { idOperationActive, idLotCommercialActif } = useLotsCommerciaux();
    const { dismiss, extractErrorMessages, inform } = useNotificationsManager();

    const [allReglements, setAllReglements] = useState([]);
    const [loaded, setLoaded] = useState([]);

    const loadReglements = useCallback((idOperation, idLotCommercial) => {
        const id = inform("Chargement des règlements...");

        Data._getReglements(idOperation, idLotCommercial).then(response => {
            if (response.codeRetour === 0) {
                const objet = response.reponseAPIobjet;
                let reglements = objet.reglements || [];
                setAllReglements(prevReglements => {
                    const merged = [...prevReglements, ...reglements];
                    return merged;
                });
                setLoaded(prevLoadedIdOperations => [...prevLoadedIdOperations, { idOperation, idLotCommercial }]);
            }
            else extractErrorMessages(response);

            dismiss(id);
        });
    }, [dismiss, extractErrorMessages, inform]);

    const reglements = useMemo(() => {
        if (!idOperationActive || !idLotCommercialActif) return [];
        const alreadyLoaded = loaded.some(item => item.idOperation === idOperationActive && item.idLotCommercial === idLotCommercialActif);
        if (!alreadyLoaded) {
            loadReglements(idOperationActive, idLotCommercialActif);
            return [];
        }
        else return allReglements.filter(reglement => reglement.idOperation === idOperationActive && reglement.idLotCommercial === idLotCommercialActif);
    }, [allReglements, idOperationActive, idLotCommercialActif, loadReglements, loaded]);

    const resetReglements = useCallback(() => {
        setAllReglements([]);
        setLoaded([]);
    }, []);

    const value = useMemo(
        () => ({ reglements }),
        [reglements]
    );

    const managerValue = useMemo(
        () => ({ resetReglements }),
        [resetReglements]
    );

    return <ReglementManagerContext.Provider value={managerValue}>
        <ReglementContext.Provider value={value}>
            {children}
        </ReglementContext.Provider>
    </ReglementManagerContext.Provider>;

};

export const useReglements = () => {
    const data = React.useContext(ReglementContext);
    if (data === undefined) throw new Error();
    const { reglements } = data;
    return { reglements };
};

export const useReglementsManager = () => {
    const manager = React.useContext(ReglementManagerContext);
    if (manager === undefined) throw new Error();
    const { resetReglements } = manager;
    return { resetReglements };
};